module.exports = __webpack_public_path__ + "img/A1-mexico.82e8ef27.png";